import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";

import { LegalEntityItemComponent } from "./legal-entity-item.component";

@NgModule({
	declarations: [LegalEntityItemComponent],
	imports: [CommonModule, MatCardModule],
	exports: [LegalEntityItemComponent]
})
export class LegalEntityItemModule {}
